import styled from "styled-components";

export const TestimonialsSection = styled.section`
  text-align: center;
  padding: 40px;
  background: #000;

  h1 {
    font-family: "Rubik";
    font-size: 2rem;
    margin-bottom: 20px;
   
  }
  p{
    font-size: 1.1rem;
  }

  b {
    color: ${props => props.theme.primary};
    font-family: "Rubik";
  }

  .swiper-container {
    margin: 0 auto;
    width: 100%;
    max-width: 800px;
  }
`;

export const TestimonialCard = styled.div`
  display: flex;
  align-items: center;
  margin: 0 auto;
  max-width: 600px;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: #242C35;
  text-align: left;
  margin-top: 44px;
  text-align: left;
  width: 250px;
  min-height: 250px;
  p{
    font-size: 1rem;
  }
`;

export const TestimonialImage = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50px;
  margin-right: 20px;
`;

